export const CREDIT_PURCHASE_URL = 'https://coveauto.ai/pricing.html';

export const openCreditPurchase = () => {
  if (typeof window === 'undefined') return;
  window.location.assign(CREDIT_PURCHASE_URL);
};
